module.exports = {"title":"Seu Veloe já está carregado! ;)","currency":"R$","disclaimer":"","buttonLabel":"Fazer nova recarga","titleEdit":"Vimos que você alterou seus dados, mas a recarga não foi efetuada.","awaitUpdate":"Dentro de alguns segundos o saldo da sua conta estará atualizado."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/RechargeConfirmation/data.json
// module id = 1856
// module chunks = 0